import styled from 'styled-components';
import tw from 'twin.macro';

export const FieldContainer = styled.div`
  ${tw`w-full`};
  display: ${(props) => (props.isHidden ? 'none' : 'block')};
  margin-bottom: ${(props) => (props.isMarginBottomZero ? '0px' : '16px')};
  ${(props) => props.css}
`;
